export var Icomoon = {
    CDN_PATH: 'https://cdn.ciceksepeti.com/static/icomoon/93363/'
};
